import { getEnv } from 'utils/env';

export const storageConfig = {
  editorAttachments: {
    bucketName: getEnv('S3_EDITOR_ATTACHMENTS_BUCKET'),
    bucketRegion: getEnv('S3_BUCKET_REGION'),
  },
};
